/* Produits offerts du pack tenus à jour dans le panier, sur tout le site (paliers du 4/11/2026) :
   1 saucisson dès 5 produits du pack, + chorizo fort dès 8, + taco dès 10 (variantes du produit masqué « Cadeau offert avec ton pack »).
   Recalculé après chaque changement du panier : ajoutés quand le palier est atteint, retirés sinon (jamais facturés), jamais en double.
   Les remises Shopify « achetez X, obtenez Y » (Pack de 5 / Pack de 8 / Pack de 10) les rendent gratuits.
   Ces remises ne comptent que les achats uniques : les lignes en abonnement (selling_plan_allocation) sont ignorées,
   sinon le cadeau serait ajouté puis facturé plein tarif.
   Seule copie active du site : les anciennes copies placées dans le corps des pages (drapeau __sbGiftSync, anciens paliers)
   sont neutralisées par sections/sb-subnav.liquid, qui pose ce drapeau avant le contenu de la page. Ce fichier utilise __sbGiftSync2. */
(function () {
  if (window.__sbGiftSync2) return;
  window.__sbGiftSync2 = 1;
  var ELIG = [10434670788939, 10434702999883, 10435171844427, 10435399221579, 10436243947851, 10444336595275, 10444457967947, 10444459573579, 10446937653579, 15625594536267];
  var GIFTS = [{ v: 58968094572875, min: 5 }, { v: 58968097325387, min: 8 }, { v: 58968097358155, min: 10 }];
  var PROP = 'Offert avec ton pack';
  var nf = window.fetch.bind(window), busy = 0, again = 0, t;
  function post(u, b) { return nf(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) }); }
  function later() { clearTimeout(t); t = setTimeout(sync, 700); }
  function sync() {
    if (busy) { again = 1; return; }
    busy = 1;
    nf('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0, lines = {};
      c.items.forEach(function (i) {
        if (ELIG.indexOf(i.product_id) > -1 && !i.selling_plan_allocation) n += i.quantity;
        GIFTS.forEach(function (g) { if (i.variant_id === g.v) (lines[g.v] = lines[g.v] || []).push(i); });
      });
      var upd = {}, add = [];
      GIFTS.forEach(function (g) {
        var want = n >= g.min ? 1 : 0, ls = lines[g.v] || [];
        ls.forEach(function (l, k) { var q = k === 0 ? want : 0; if (l.quantity !== q) upd[l.key] = q; });
        if (want && !ls.length) add.push({ id: g.v, quantity: 1, properties: { Cadeau: PROP } });
      });
      var p = Promise.resolve(), changed = false;
      if (Object.keys(upd).length) { changed = true; p = p.then(function () { return post('/cart/update.js', { updates: upd }); }); }
      if (add.length) { changed = true; p = p.then(function () { return post('/cart/add.js', { items: add }); }); }
      return p.then(function () { if (changed) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
    }).catch(function () {}).then(function () { busy = 0; if (again) { again = 0; later(); } });
  }
  var isCart = function (u) { return /[/]cart[/](add|change|update|clear)([.]js)?([?]|$)/.test(u || ''); };
  var of = window.fetch;
  window.fetch = function (i) {
    var u = typeof i === 'string' ? i : (i && i.url) || '';
    var r = of.apply(this, arguments);
    if (isCart(u)) r.then(later, later);
    return r;
  };
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { if (isCart(u)) this.addEventListener('loadend', later); return oo.apply(this, arguments); };
  document.addEventListener('cart:change', later);
  later();
})();
